import React, { useEffect } from 'react';
import { useAppContext } from '../contexts/AppContext';
import * as authService from '../services/auth';

const LogoutPage: React.FC = () => {
  const { logout: clearAppState } = useAppContext();

  useEffect(() => {
    // Clear app context authentication state
    clearAppState();

    // Call auth service logout (clears tokens and redirects to Cognito logout)
    authService.logout();
  }, [clearAppState]);

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      <div className="bg-white shadow rounded-lg p-8">
        <div className="flex items-center space-x-3">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
          <p className="text-gray-700">Logging out...</p>
        </div>
      </div>
    </div>
  );
};

export default LogoutPage;
